'use client';

import { createContext, useContext, type ReactNode } from 'react';
import type { Runtime } from './host';

const RuntimeContext = createContext<Runtime | null>(null);
const HostContext = createContext<string>('');

export const RuntimeProvider = ({
  runtime,
  host = '',
  children,
}: {
  runtime: Runtime;
  host?: string;
  children: ReactNode;
}) => (
  <RuntimeContext.Provider value={runtime}>
    <HostContext.Provider value={host}>{children}</HostContext.Provider>
  </RuntimeContext.Provider>
);

export function useRuntime(): Runtime {
  const r = useContext(RuntimeContext);
  if (!r) throw new Error('useRuntime called outside RuntimeProvider');
  return r;
}

export function useHost(): string {
  return useContext(HostContext);
}
